import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bar-percentagem',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bar-percentagem.component.html',
  styleUrl: './bar-percentagem.component.scss'
})
export class BarPercentagemComponent {
  @Input() percentage: number = 0;
}
